<template lang="pug">
  v-card-text
    file-upload(
      ref="fileUploader"
      label="Файл к уроку"
      hint="Допустимые виды файлов: png, jpg, pdf, pptx, docx, doc. Максимальный размер 64 МБ"
      vid="file"
      name="Файл"
      :existing-file-name="file.file_name"
      :existing-file-url="file.url"
      @file:changed="addFile"
      :error-messages="errors"
    )

</template>

<script>
import FileUpload from '@/components/InputFields/FileUpload.vue';

export default {
  name: 'TypeFile',
  components: {
    FileUpload,
  },
  data: () => ({
    file: {
      name: '',
      file_name: '',
    },
    loading: false,
  }),
  methods: {
    emitAnswer(filename) {
      this.$emit('answer', {
        fieldName: 'file_name',
        answer: filename,
      });
    },

    async addFile() {
      this.loading = true;
      try {
        this.file = await this.$refs.fileUploader.uploadFile();
        this.emitAnswer(this.file.file_name);
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log('Ошибка при загрузке файла', e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
